export default __webpack_public_path__ + "static/Metal-48896afb88735b58ae084af2a42af019.png";